import { render, staticRenderFns } from "./shoppings.vue?vue&type=template&id=079c43b0"
import script from "./shoppings.vue?vue&type=script&lang=js"
export * from "./shoppings.vue?vue&type=script&lang=js"
import style0 from "./shoppings.vue?vue&type=style&index=0&id=079c43b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports